<template>
  <div class="ticket-detail">
    <ticket-information :ticket="ticket" />

    <ticket-messages :messages="ticket.messages" />

    <v-card class="mb-4" v-if="canEdit">
      <v-card-text>
        <alert/>
        <v-form ref="ticketForm">
          <v-row>
            <v-col cols="12" md="12">
              <v-textarea
                dense
                outlined
                v-model="form.message"
                :rules="rules.message"
                hide-details="auto"
                rows="3"
                :label="$t('Message')"
                :placeholder="$t('Enter your message')"
              ></v-textarea>
            </v-col>
            <v-col cols="12" md="12">
              <v-file-input
                counter
                dense
                multiple
                show-size
                :label="$t('Select your files')"
                prepend-icon=""
                append-icon="mdi-paperclip"
                outlined
                hide-details="auto"
                v-model="form.files_upload"
                accept=".doc,.docx,.pdf,.xls,.xlsx,.ppt,.pptx,.txt,.jpg,.jpeg,.png,.gif"
                :rules="rules.document"
              >
                <template v-slot:selection="{ index, text }">
                  <v-chip v-if="index < 2" label small>
                    {{ text }}
                  </v-chip>
                </template>
              </v-file-input>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
    <div class="text-center my-5">
      <v-btn color="secondary" @click="__back('tickets.index', $event)" class="mr-3">{{
        $t('Back')
      }}</v-btn>
      <v-btn v-if="canEdit" color="primary" @click="submit">
        {{ $t('Submit') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import TicketMessages from './components/TicketMessages'
import TicketInformation from './components/TicketInformation'
import validation from '@utils/validation'
import { get, call } from 'vuex-pathify'
import jsonToFormData from 'json-form-data'
import Alert from '@components/Alert'
import _ from 'lodash'

export default {
  components: {
    TicketMessages,
    TicketInformation,
    Alert
  },

  data() {
    return {
      valid: true,

      form: {
        message: '',
        files_upload: []
      },

      rules: {
        message: [
          (v) => validation.required(v),
          (v) => validation.minlength(v, 5)
        ],
        document: [
          (v) => validation.accept(v),
          (v) => validation.arrayMax(v, 5),
          (v) => validation.filesize(v, 10 * 1024 * 1024)
        ]
      }
    }
  },

  computed: {
    ticket: get('ticket/ticket'),
    userId: get('user/id'),

    id() {
      return this.$route.params.id
    },

    canEdit() {
      if (this.userId !== this.ticket.user_id &&
      this.userId !== this.ticket.manager_id
      ) {
        return false
      }

      const status = _.get(this.ticket, 'task.status')

      return ['pending', 'in_progress'].includes(status)
    }
  },

  mounted() {
    this.getTicket(this.id)
  },

  methods: {
    createMessage: call('ticket/createMessage'),
    getTicket: call('ticket/getTicket'),
    hideAlert: call('alert/hide'),
    loading: call('app/setLoading'),

    async submit(e) {
      e.preventDefault()
      const valid = this.$refs.ticketForm.validate()
      if (!valid) {
        alert(this.$t('Please check data before submit!'))
        return false
      } else {
        this.hideAlert()
        this.loading(true)

        const ticketId = this.id
        const data = { ...this.form }
        const formData = {
          id: ticketId,
          data: jsonToFormData(data)
        }
        const res = await this.createMessage(formData)
        this.loading(false)
        if (res) {
          this.$refs.ticketForm.reset()
        }
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/sass/_ticket.scss';
</style>
